/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const dataRemovalRequestDecisionSourceSchema = z.enum(['manual', 'auto'])

export type DataRemovalRequestDecisionSourceSchema = z.infer<typeof dataRemovalRequestDecisionSourceSchema>
